export async function enableMocking(realm: string) {

    if (["master", "demo"].includes(realm)) {
        const {worker} = await import("./browser");
        return worker.start({onUnhandledRequest: "bypass"});
    }
    return;
}


